import Api from './Api';

const Compounds = () => {
  return Api().get('/compounds');
};

const Compound = (id) => {
  return Api().get(`/compounds/${id}`);
};

const AddCompound = (data) => {
  return Api().post('/compounds', data);
};

const EditCompound = (id, data) => {
  return Api().put(`/compounds/${id}`, data);
};

const DescartaCompound = (id, data) => {
  return Api().put(`/compounds/discard/${id}`, data);
};

const RemoveCompound = (id) => {
  return Api().delete(`/compounds/${id}`);
};

export {
  Compounds,
  Compound,
  AddCompound,
  EditCompound,
  RemoveCompound,
  DescartaCompound,
};
